import React from "react";
import PropTypes from "prop-types";
import ccAuthLogon from "./ccAuthLogon";

export default function(params) {
  const ccAuthLogon_ = ccAuthLogon(params);
  class Logon extends React.Component {
    clearFields = evt => {
      if (evt) evt.preventDefault();
      this.form.reset();
      this.user.focus();
    };

    componentDidMount() {
      this.user.focus();
    }

    logon = evt => {
      evt.preventDefault();
      ccAuthLogon_({
        user: this.user.value,
        password: this.password.value
      })
        .then(this.props.onSuccess)
        .catch(this.props.onFail);
    };

    render() {
      return (
        <div className={this.props.className}>

          <form action="" onSubmit={this.logon} ref={el => (this.form = el)}>
            <label htmlFor="user">Usuário:</label>
            <input type="text" name="user" ref={input => (this.user = input)} />

            <label htmlFor="password">Senha:</label>
            <input
              type="password"
              name="password"
              ref={input => (this.password = input)}
            />

            <button type="submit">Acessar</button>
          </form>
        </div>
      );
    }
  }

  Logon.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onFail: PropTypes.func.isRequired
  };

  return Logon;
}
